import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="footer">
                <div className="footer-text">Powerd by ORIPAL</div>
            </div>
        </>
    )
}

export default Footer